import { render, staticRenderFns } from "./home-top-destinations-item.vue?vue&type=template&id=5cc357f0&scoped=true"
import script from "./home-top-destinations-item.vue?vue&type=script&lang=js"
export * from "./home-top-destinations-item.vue?vue&type=script&lang=js"
import style0 from "./home-top-destinations-item.vue?vue&type=style&index=0&id=5cc357f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc357f0",
  null
  
)

export default component.exports